import { makeStyles } from '@fluentui/react-components';
import { MonicaValechaTokens } from '../../theme/theme';
import { shorthands } from '@griffel/react';
import type { JobCardStyles } from './JobCard.types';

const useJobCardStyles = makeStyles<keyof JobCardStyles>({
  root: {
    ...shorthands.borderRadius('8px'),
    ...shorthands.padding('16px'),
    ...shorthands.gap('16px'),
    backgroundColor: MonicaValechaTokens.jobCardBackground,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    height: '100%',
  },
  smallGap: {
    ...shorthands.gap('8px'),
  },
  title: {
    fontSize: '20px',
    fontWeight: '700',
    lineHeight: '24px',
    width: '100%',
    textAlign: 'center',
  },
  position: {
    ...shorthands.gap('4px'),
    ...shorthands.padding('0'),
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '16px',
    textAlign: 'center',
    width: '100%',
    color: '#585858',
  },
  logo: {},
  date: {
    ...shorthands.borderTop('1px', 'solid', 'rgb(87, 87, 87)'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    fontSize: '12px',
    fontWeight: '800',
    lineHeight: '13px',
    width: '100%',
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  location: {
    ...shorthands.borderTop('1px', 'solid', 'rgb(87, 87, 87)'),
    ...shorthands.borderBottom('1px', 'solid', 'rgb(87, 87, 87)'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    fontSize: '12px',
    fontWeight: '800',
    lineHeight: '13px',
    width: '100%',
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  compactLocation: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '13px',
    width: '100%',
  },
  highlights: {
    ...shorthands.padding('0', '16px'),
    boxSizing: 'border-box',
    listStyleType: 'circle',
  },
  highlight: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px',
    textAlign: 'start',
  },
  tags: {
    ...shorthands.gap('8px'),
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '16px',
  },
  tag: {
    ...shorthands.padding('8px', '16px'),
    ...shorthands.borderRadius('8px'),
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E4B3B9',
    fontWeight: '400',
  },
});

export { useJobCardStyles };
